import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  connect() {
    this.wasHidden = document.hidden
    this.refreshWhenVisible = this.refreshWhenVisible.bind(this)
    this.refreshFromPageCache = this.refreshFromPageCache.bind(this)

    document.addEventListener("visibilitychange", this.refreshWhenVisible)
    window.addEventListener("pageshow", this.refreshFromPageCache)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.refreshWhenVisible)
    window.removeEventListener("pageshow", this.refreshFromPageCache)
  }

  refreshWhenVisible() {
    if (document.hidden) {
      this.wasHidden = true
    } else if (this.wasHidden) {
      this.refresh()
    }
  }

  refreshFromPageCache(event) {
    if (event.persisted) this.refresh()
  }

  refresh() {
    this.wasHidden = false
    visit(window.location.href, { action: "replace" })
  }
}
